export const AnonymousReportServiceType = Symbol.for('AnonymousReportService');
